import user from '@/store/modules/handbook/user'
import pto from '@/store/modules/handbook/pto'
import contracts from '@/store/modules/handbook/contracts'
import partner from '@/store/modules/handbook/partner'
import logistic from '@/store/modules/handbook/logistic'

const state = () => ({})
const getters = {}
const mutations = {}
const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
  modules: {
    logistic,
    user,
    pto,
    contracts,
    partner
  }
}
